import { BooleanBase } from '../BooleanBase';

export class PremiumContent extends BooleanBase {}
